import { Ownership } from '#profile/schemas'
import type { Question } from '#survey'

import type { SubmissionAnswerValue } from '..'

type DefaultValueBuilder<Q> = (question: Q) => SubmissionAnswerValue

const BUILDERS: {
  [Q in Question as Q['type']]: DefaultValueBuilder<Q>
} = {
  string: question => question.defaultValue ?? '',
  integer: question => question.defaultValue ?? null,
  boolean: question => question.defaultValue ?? false,
  date: () => null,
  zipCode: () => '',
  money: question => question.defaultValue ?? null,
  moneyWithPeriod: question => question.defaultValue ?? null,
  percentage: question => question.defaultValue ?? null,
  singleSelect: question => question.defaultValue ?? '',
  categorySelect: () => '',
  owner: () => Ownership.Person,
}

export const buildDefaultValue = <Q extends Question>(
  question: Q
): SubmissionAnswerValue => {
  const builder = BUILDERS[question.type] as DefaultValueBuilder<Q>
  return builder(question)
}
